import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    about: null,
  },

  mutations: {
    INIT_ABOUT(state) {
      state.about = {
        id: null,
        title: null,
        subtitle: null,
        banner: null,
        corporate_title: null,
        corporate_subtitle: null,
        partners: [],
        investor_title: null,
        investor_call_to_action: null,
        investor_visual: null,
        investor_relations_contact: null,
        investor_agent_contact: null,
        investor_quick_link: null,
        csr_title: null,
        csr_description: null,
        csr_call_to_action: null,
        csr_visual: null,
        csr_highlight: [],
        employee_title: null,
        employee_description: null,
        employee_call_to_action: null,
        employee_visual: null,
        employee_highlight: [],
        video_rotates: [],
        partner_title: null,
        partner_subtitle: null,
        partner_banner: null,
      };
    },
    CLEAR_ABOUT(state) {
      state.about = null;
    },
    SET_ABOUT(state, data) {
      state.about = data;
    },
  },

  getters: {
    about(state) {
      return state.about;
    },
  },

  actions: {
    init({ commit }) {
      commit('INIT_ABOUT');
    },

    clear({ commit }) {
      commit('CLEAR_ABOUT');
    },

    setAbout({ commit }, data) {
      commit('SET_ABOUT', data);
    },

    find({ commit }) {
      return http('/about')
        .then((response) => response.body)
        .then(typeAs('About'))
        .then((response) => {
          commit('SET_ABOUT', response);
          return response;
        });
    },

    save(_, data) {
      const request = http('/about', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

  },
};
